import React from 'react';
import { createStackNavigator } from 'react-navigation-stack';
import { View } from 'react-native';
import WifiListScreen from './WifiListScreen';
import WifiConnectScreen from './WifiConnectScreen';
import Theme from '../../theme';
import { BackButton } from '../../Profile/components/BackButton';

const hasNavigationSource = (navigation) => !!navigation.getParam('navigationSource');

const buildWifiNavigator = () => {
  return createStackNavigator(
    {
      WifiList: {
        screen: WifiListScreen,
        navigationOptions: ({ navigation }) => ({
          headerTitle: () => <View />,
          headerLeft: () => hasNavigationSource(navigation) ? (<BackButton navigation={navigation} color={Theme.PRIMARY} size={20} />) : null,
        }),
      },
      ConnectToWifi: {
        screen: WifiConnectScreen,
        navigationOptions: ({ navigation }) => ({
          headerTitle: () => <View />,
          headerLeft: () => <BackButton navigation={navigation} color={Theme.PRIMARY} size={20} />,
        }),
      },
    },
    {
      defaultNavigationOptions: ({ navigation }) => ({
        initialRouteName: 'WifiSetup',
        headerStyle: {
          shadowColor: 'transparent',
          backgroundColor: '#fff',
          elevation: 0,
        },
      }),
    },
  );
};

export default buildWifiNavigator;
